// useSdsOnline.js
// Browser-level connectivity for the SDS Lookup tab (v4 has no app-wide server-reachability hook).

import { useEffect, useState } from "react";

// navigator.onLine false is trustworthy; true only means a network interface is up
const readOnline = () =>
  typeof navigator !== "undefined" && "onLine" in navigator ? navigator.onLine : true;

export const useSdsOnline = () => {
  const [isBrowserOnline, setIsBrowserOnline] = useState(readOnline);

  useEffect(() => {
    const sync = () => setIsBrowserOnline(readOnline());
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);
    // A home-screen app resumed from the background may have missed the events
    document.addEventListener("visibilitychange", sync);
    sync();
    return () => {
      window.removeEventListener("online", sync);
      window.removeEventListener("offline", sync);
      document.removeEventListener("visibilitychange", sync);
    };
  }, []);

  // Same shape as V5's useServerConnection so SdsLookupTab reads it unchanged
  return { isServerReachable: isBrowserOnline };
};
